"use strict";
// tslint:disable:max-line-length
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=JsonLdContext.js.map